import React from "react";

export default function OrgCell({ name, type }) {
  return (
    <div style={{ lineHeight: 1.35 }}>
      <div>{name || "-"}</div>
      {type ? (
        <div style={{ color: "#94a3b8", fontSize: 12, marginTop: 2 }}>
          {type}
        </div>
      ) : null}
    </div>
  );
}
